import update from 'immutability-helper';
import {
  OPEN_LAYER_PLUGIN_MODAL,
  CLOSE_LAYER_PLUGIN_MODAL
} from '@/constants/ActionTypes';

const initialState = {
  name: null,
  isOpen: false
};

export default (state = initialState, action) => {
  switch(action.type) {
    case OPEN_LAYER_PLUGIN_MODAL:
      return update(state, {
        name: { $set: action.layerModalPluginName },
        isOpen: { $set: true },
      })
    case CLOSE_LAYER_PLUGIN_MODAL:
      return update(state, {
        $set: initialState
      })
    default:
      return state;
  }
};
